<div class="ion-page" *ngIf="pageMode">
  <ng-container *ngIf="true then main"></ng-container>
</div>

<ng-container *ngIf="!pageMode then main"></ng-container>

<ng-template #main>
  <ion-header #header>
    <ion-toolbar color="light">
      <ion-buttons slot="start">
        <ion-menu-button *ngIf="pageMode else menuBtnBlock">
          <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
          <app-inbox-count></app-inbox-count>
        </ion-menu-button>
        <ng-template #menuBtnBlock>
          <ion-button (click)="goBack()">
            <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
          </ion-button>
        </ng-template>
      </ion-buttons>
      <ion-title>
        <app-offline-indicator></app-offline-indicator>
        {{ 'MODULE.action.gift.new' | translate }}
      </ion-title>
    </ion-toolbar>
    <ion-toolbar color="light" *ngIf="!preview">
      <div class="content-div">
        <ion-item class="ion-item-no-padding ion-padding-horizontal" color="light" lines="none">
          <ion-label position="stacked" color="dark">{{ 'GIFT.lbl.qty' | translate }}</ion-label>
          <ion-item class="prompt-input-item ion-item-no-padding full-width" lines="none">
            <ion-input class="ion-text-center" [(ngModel)]="total" min="1" type="number" inputmode="numeric" (ionChange)="setupGiftList()">
              <ion-button class="qty-btn" slot="start" (click)="minusTotal()" fill="clear">
                <ion-icon name="remove"></ion-icon>
              </ion-button>
              <ion-button class="qty-btn" slot="end" (click)="addTotal()" fill="clear">
                <ion-icon name="add"></ion-icon>
              </ion-button>
            </ion-input>
          </ion-item>
          <ion-item class="total-toolbar full-width background-transparent ion-text-center" lines="none">
            <div class="font-12 ion-text-center full-width" *ngIf="total > 1">
              {{ 'SUMMARY.no_of_total_field' | translate: { no: index + 1, total: total, field: total === 1 ? ('GIFT.lbl.gift' | translate) : ('GIFT.lbl.gifts' | translate) } }}
            </div>
          </ion-item>
        </ion-item>
      </div>
    </ion-toolbar>
    <!-- <ion-toolbar class="total-toolbar" color="light" *ngIf="!preview">
      
    </ion-toolbar> -->
    <ion-toolbar class="ion-no-padding" color="light" *ngIf="preview">
      <div class="content-div ion-padding-horizontal ion-padding-top">
        <app-gift-summary [giftSummary]="giftSummary"></app-gift-summary>
      </div>
    </ion-toolbar>
  </ion-header>
  <ion-content class="full-width" color="light" #content>
    <div class="content-div">
      <ng-container *ngIf="!preview">
        <app-gift-manage class="full-width full-height" *ngIf="giftList" [setGift]="giftList[index]" [componentMode]="true" [index]="index" [total]="total" (output)="setupGift($event, index)"></app-gift-manage>
      </ng-container>
      <ng-container *ngIf="preview">
        <div class="full-width-height ion-padding viewport-div" *ngIf="giftList?.length">
          <cdk-virtual-scroll-viewport [itemSize]="87">
            <ion-list class="full-width-height background-transparent ion-padding-bottom" lines="none" #list>
              <app-gift-item *cdkVirtualFor="let gift of giftList; trackBy: trackByFn; let index = index;" [setGift]="gift" [index]="index"></app-gift-item>
            </ion-list>
          </cdk-virtual-scroll-viewport>
        </div>
      </ng-container>
    </div>
  </ion-content>
  <ion-footer class="ion-border" *ngIf="preview" #footer>
    <ion-toolbar>
      <div class="content-div">
        <ion-grid>
          <ion-row>
            <!-- <ion-col><ion-button expand="block" color="medium" (click)="goBack()">{{ 'BTN.back' | translate }}</ion-button></ion-col> -->
            <ion-col><ion-button expand="block" (click)="initialize()">{{ 'CRUD.new' | translate }}</ion-button></ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-toolbar>
  </ion-footer>
</ng-template>
